import React from 'react';
import { Card, Row, Table } from 'react-bootstrap';
import _ from 'lodash';

import BudgetTableMisc from './BudgetTableMisc';
import BudgetTableSf from './BudgetTableSf';
import BudgetTableFb from './BudgetTableFb';

import { floatRenderer } from '../../../services/formatSvc';
import {GREEN_COLOR_JS} from "../../../utils/consts";
import {getCurrentStyle} from "../../../helpers/passport";

export default function Budget({dataStatus, data, finSources, acceptedData, strategyType, isNew }) {
  const dataGrouped = _.groupBy(data, 'type');
  const acceptedDataGrouped = _.groupBy(acceptedData, 'type');
  const finSourcesByKeys = _.keyBy(finSources, 'type');
  const total = data.reduce((prev, d) => prev + d.sum, 0);
  const acceptedTotal = acceptedData?.reduce((prev, d) => prev + d?.sum, 0);
  return (
    <div className="read-only">
      <Card className="mb-4">
        <Card.Header as={Card.Title} className="p-4">Бюджет</Card.Header>
        <Card.Body className="p-4">
          { dataGrouped.fb && finSourcesByKeys.fb
            && (
            <Row className="mb-4">
              <Card.Subtitle className="mb-2 text-muted">Грант</Card.Subtitle>
              <BudgetTableFb status={dataStatus} data={dataGrouped.fb} finSource={finSourcesByKeys.fb} acceptedData={acceptedDataGrouped.fb} strategyType={strategyType} isNew={isNew} />
            </Row>
            )}
          { dataGrouped.sf && finSourcesByKeys.sf
            && (
            <Row className="mb-4">
              <Card.Subtitle className="mb-2 text-muted">Софинансирование</Card.Subtitle>
              <BudgetTableSf status={dataStatus} data={dataGrouped.sf} finSource={finSourcesByKeys.sf} acceptedData={acceptedDataGrouped.sf} strategyType={strategyType} />
            </Row>
            )}
          {/* { dataGrouped.misc && finSourcesByKeys.misc && */}
          {/*  <Row className="mb-4"> */}
          {/*    <Card.Subtitle className="mb-2 text-muted">Иные источники</Card.Subtitle> */}
          {/*    <BudgetTableMisc data={dataGrouped.misc} finSource={finSourcesByKeys.misc} /> */}
          {/*  </Row> */}
          {/* } */}
          <Row>
            {/*<Card.Text style={{ textAlign: 'right', color: acceptedTotal !== total ? GREEN_COLOR_JS : '' }}>*/}
            <Card.Text style={(()=>{
              return {...{textAlign:'right'},...getCurrentStyle(dataStatus,total && {total:total},acceptedTotal && {total:acceptedTotal},'total')}
            })()}>
              {`Общая сумма (руб.): ${floatRenderer(total)}`}
            </Card.Text>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end', minHeight: 38,
};
